import { defineMessages } from 'react-intl'

const messages = {
 consolidate: {
    id: 'app.components.cycle-order.consolidate',
    defaultMessage: 'Consolidate',
  },
}

export default defineMessages(messages)
